import { PlanTier, PlanLimits } from './types';

/**
 * Plan limits configuration
 */
export const PLAN_LIMITS: Record<PlanTier, PlanLimits> = {
  Personal: { maxProfiles: 1, maxAccounts: 2, maxCards: 'unlimited' },
  Plus: { maxProfiles: 3, maxAccounts: 5, maxCards: 'unlimited' },
  Pro: { maxProfiles: 'unlimited', maxAccounts: 'unlimited', maxCards: 'unlimited' },
};

/**
 * Stripe price IDs for each plan
 * Valores atualizados: R$ 9,90 / R$ 19,90 / R$ 49,90 mensais
 * Anuais (2 meses grátis): R$ 99 / R$ 199 / R$ 499
 */
export const PLAN_PRICES = {
  Personal: {
    monthly: 'price_1SkyFfHsagPmSTysJFbSfarr',  // R$ 9,90/mês
    yearly: 'price_1SkyFoHsagPmSTyspOtGG0ZX'    // R$ 99/ano
  },
  Plus: {
    monthly: 'price_1SkyFqHsagPmSTysqpdHTEVc',  // R$ 19,90/mês
    yearly: 'price_1SkyFrHsagPmSTysORgDhGr9'   // R$ 199/ano
  },
  Pro: {
    monthly: 'price_1SkyFtHsagPmSTysaViUR72J',  // R$ 49,90/mês
    yearly: 'price_1SkyFvHsagPmSTysV8cpbEsE'   // R$ 499/ano
  }
} as const;

/**
 * Get plan limits for a given tier
 */
export function getPlanLimits(tier: PlanTier): PlanLimits {
  return PLAN_LIMITS[tier];
}

/**
 * Check if subscription is expiring soon
 */
export function checkSubscriptionExpiring(subscriptionEnd: string | null): { 
  isExpiring: boolean; 
  daysUntilEnd: number;
  hasExpired: boolean;
} {
  if (!subscriptionEnd) {
    return { isExpiring: false, daysUntilEnd: Infinity, hasExpired: false };
  }

  const endDate = new Date(subscriptionEnd);
  const now = new Date();
  const daysUntilEnd = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  
  return {
    isExpiring: daysUntilEnd <= 7 && daysUntilEnd > 0,
    daysUntilEnd,
    hasExpired: daysUntilEnd <= 0
  };
}

/**
 * Check if a limit allows more items
 */
export function canAddItem(limit: number | 'unlimited', currentCount: number): boolean {
  if (limit === 'unlimited') return true;
  return currentCount < limit;
}
